import type { IErrorValue } from "./types";

export type ExcludeErrorValue<T> = T extends IErrorValue ? never : T;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isErrorValue(value: any): value is IErrorValue {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return typeof value?.error?.message !== "undefined";
}

export { isErrorValue };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function formatApiError(result: IErrorValue) {
  if (typeof result?.error === "string") {
    return result.error;
  }

  /**
   * For example, if the error is an array of objects like this:
   * ```ts
   * [
   *   {
   *     property: "isInvestedInEnterprise",
   *     constraints: {
   *       whitelistValidation:
   *         "property isInvestedInEnterprise should not exist",
   *     },
   *   },
   *   {
   *     property: "isInvestedInEnterprise",
   *     constraints: { isString: "isInvestedInEnterprise must be a string" },
   *   },
   * ];
   * ```
   */
  const error = result?.error as unknown as {
    property: string;
    constraints: Record<string, string>;
  }[];
  if (Array.isArray(error)) {
    if (error[0] && "property" in error[0] && "constraints" in error[0]) {
      return `${error[0].property} ${Object.entries(error[0].constraints)
        .map(([key, value]) => `${key} ${value}`)
        .join(", ")}`;
    }
  }

  return result?.error?.message;
}
